/**
 * Service archive: category tabs (no reload), Load More, URL ?category= & ?item=.
 *
 * @package Naari
 */

(function () {
	'use strict';

	function getParams() {
		var params = new URLSearchParams(window.location.search);
		return {
			category: params.get('category') || '',
			item: params.get('item') || '',
		};
	}

	function setUrl(category, item) {
		var url = new URL(window.location.href);
		if (category) url.searchParams.set('category', category);
		else url.searchParams.delete('category');
		if (item) url.searchParams.set('item', item);
		else url.searchParams.delete('item');
		window.history.replaceState({}, '', url.toString());
	}

	function initServiceArchive() {
		var section = document.getElementById('services-content');
		if (!section) return;

		// Sticky menu: apply hover-like background when position:sticky reaches top.
		// This prevents the visual jump where it becomes fixed but stays the default bg.
		var stickyMenu = document.querySelector('.services-sticky-menu');
		var stickyTopPx = null;
		if (stickyMenu) {
			var stickyTopStr = getComputedStyle(stickyMenu).top;
			stickyTopPx = parseFloat(stickyTopStr);
			if (Number.isNaN(stickyTopPx)) {
				stickyTopPx = 80;
			}
		}

		var pills = section.querySelectorAll('.services-category__link');
		var panels = section.querySelectorAll('.services-list-panel');
		var loadMoreBtns = section.querySelectorAll('.js-services-loadmore');

		function activateCategory(slug) {
			pills.forEach(function (a) {
				var active = a.getAttribute('data-category') === slug;
				a.parentElement.classList.toggle('services-category--active', active);
				a.setAttribute('aria-current', active ? 'true' : 'false');
			});
			panels.forEach(function (panel) {
				var isActive = panel.getAttribute('data-category') === slug;
				panel.classList.toggle('services-list-panel--active', isActive);
				panel.hidden = !isActive;
			});
			// Scroll section into view so content (or empty state) is visible, not footer
			if (section) {
				section.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}

		function expandLoadMore(panel) {
			var list = panel.querySelector('.services-list');
			var hidden = list ? list.querySelectorAll('.service-item.service-item--hidden') : [];
			// Reveal with stagger for smooth animation (CSS transition on class remove)
			hidden.forEach(function (el, i) {
				setTimeout(function () {
					el.classList.remove('service-item--hidden');
				}, i * 80);
			});
			var wrap = panel.querySelector('.services-loadmore-wrap');
			if (wrap) {
				setTimeout(function () {
					wrap.classList.add('is-expanded');
				}, hidden.length * 80 + 350);
			}
			var btn = panel.querySelector('.js-services-loadmore');
			if (btn) {
				btn.setAttribute('aria-expanded', 'true');
				btn.style.display = 'none';
			}
		}

		function scrollToService(el) {
			if (!el) return;
			el.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		// Toggle sticky "stuck" class using rAF to keep scrolling smooth.
		if (stickyMenu) {
			var lastStuck = null;
			var ticking = false;

			function handleSticky() {
				var rect = stickyMenu.getBoundingClientRect();
				// When stuck, rect.top should be approximately equal to the CSS `top` offset.
				var isStuckNow = rect.top <= stickyTopPx + 1;
				if (isStuckNow === lastStuck) return;
				lastStuck = isStuckNow;
				stickyMenu.classList.toggle('is-stuck', isStuckNow);
			}

			function onScrollOrResize() {
				if (ticking) return;
				ticking = true;
				requestAnimationFrame(function () {
					handleSticky();
					ticking = false;
				});
			}

			handleSticky();
			window.addEventListener('scroll', onScrollOrResize, { passive: true });
			window.addEventListener('resize', onScrollOrResize);
		}

		// Category click: prevent default, switch panel, update URL
		pills.forEach(function (a) {
			a.addEventListener('click', function (e) {
				var slug = a.getAttribute('data-category');
				if (!slug) return;
				e.preventDefault();
				activateCategory(slug);
				setUrl(slug, '');
			});
		});

		// Load More: reveal hidden items, hide button
		loadMoreBtns.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var cat = btn.getAttribute('data-category');
				var panel = section.querySelector('.services-list-panel[data-category="' + cat + '"]');
				if (!panel) return;
				expandLoadMore(panel);
				btn.setAttribute('aria-expanded', 'true');
				setUrl(cat, '');
			});
		});

		// Initial URL: ?item=service-slug
		var params = getParams();
		if (params.item) {
			var serviceEl = section.querySelector('.service-item[data-service-slug="' + params.item + '"]');
			if (serviceEl) {
				var list = serviceEl.closest('.services-list');
				var cat = list ? list.getAttribute('data-category') : '';
				if (cat) {
					activateCategory(cat);
					var panel = section.querySelector('.services-list-panel[data-category="' + cat + '"]');
					if (panel && serviceEl.classList.contains('service-item--hidden')) {
						expandLoadMore(panel);
					}
					requestAnimationFrame(function () {
						scrollToService(serviceEl);
					});
				}
			}
		} else if (params.category) {
			var hasPanel = section.querySelector('.services-list-panel[data-category="' + params.category + '"]');
			if (hasPanel) activateCategory(params.category);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initServiceArchive);
	} else {
		initServiceArchive();
	}
})();
